<template> 
        <div :class="locationMap.percentage <= 50 ? 'map_card_green map_card' : (locationMap.percentage <= 80 ? 'map_card_yellow map_card' : 'map_card_red map_card')">
            <div>
                <div class="map_ckname_flex">
                    <div class="map_ckname">
                        {{locationMap.name}} 
                        <span class="map_manageProperty">（{{locationMap.manageProperty}}）</span> 
                    </div>
                    <div class="map_area">面积：{{ locationMap.area }}m²</div>
                </div>
                <div class="map_remark">{{ locationMap.remark }}</div>
            </div>
            <div>
                <div class="map_totalWeight"> <span style="font-weight: 600;">{{ locationMap.totalWeight ? locationMap.totalWeight : 0 }}</span>  / {{ locationMap.capacity }} （吨）</div>
                <el-progress :percentage="locationMap.percentage" ></el-progress>
            </div>
        </div>
</template>
<script>
export default {
    name: 'locationMapCard',
    mixins: [],
    props: {
        locationMapCard: {
            type: Object,
            default: () => {}
        }
    },
    components:{
        
    },
    watch: { 
        locationMapCard:{
            handler(val) {
                const item = { ...val }
                const rawWeight = Number(item.totalWeight) || 0
                item.totalWeight = (rawWeight / 1000).toFixed(2)
                const cap = Number(item.capacity) || 0

                const percentage = Math.round(((item.totalWeight / cap) * 100))
                item.percentage = percentage
                this.locationMap  = item
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            locationMap: {}
        }
    },
    mounted() {
        
    },
    created() {

      
    },
    methods: {
      
    },
    beforeDestroy() {
        
   
    }
}
</script>
<style lang="less" scoped>
.map_card{
    margin: 10px;
    box-sizing: border-box;
    min-width: 320px;
    max-width: 380px;
    height: 170px;
    border-radius: 15px;
    padding: 20px  20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.map_ckname_flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.map_card_green{
    background: linear-gradient(135deg, #f3fcf8 0%, #e6f7ef 100%);
    // background: linear-gradient(90deg, #52c48a, #36b372);
}
.map_card_green /deep/ .el-progress-bar__inner {
    background: linear-gradient(90deg, #63d49aa9, #36b372);
}
.map_card_yellow{
    background: linear-gradient(135deg, #fffbf0 0%, #fff2d9 100%);
}
.map_card_yellow /deep/ .el-progress-bar__inner {
    background: linear-gradient(90deg, #f8c45cd7, #ffaa2e);
}
.map_card_red{
    background: linear-gradient(135deg, #fef4f4 0%, #fee7e7 100%);
    // background: linear-gradient(90deg, #f77878, #ec4b4b);
}
.map_card_red /deep/ .el-progress-bar__inner {
    background: linear-gradient(90deg, #f77878dc, #ec4b4b);
}
.map_ckname{
    font-size: 20px;
    font-weight: 600;
    color: #333333;
}
.map_manageProperty{
    font-size: 14px;
    color: #409eff;
}
.map_remark{
    width: 100%;
    word-break: break-all;
    margin-top: 10px;
    font-size: 14px;
    color: #303133;
}
.map_area{
    font-size: 14px;
    color: #303133;
}
.map_card_green .map_totalWeight{
    color: #165D36;
}
.map_card_yellow .map_totalWeight{
    color: #874300;
}
.map_card_red .map_totalWeight{
    color: #A62323;
}
</style>